import cnsIcon from "../img/brain-question.png";
import medullaIcon from "../img/medulla-question.png";
import cerebellumIcon from "../img/cerebellum-question.png";
import hippocampusIcon from "../img/hippocampus-question.png";
import cortexIcon from "../img/cerebralcortex-question.png";
import hypothalymusIcon from "../img/hypothalamus-question.png";

import cnsPlay from "../img/brain-play.png";
import medullaPlay from "../img/medulla-play.png";
import cerebellumPlay from "../img/strong-play.png";
import hippocampusPlay from "../img/seahorse-play.png";
import cortexPlay from "../img/colorful-play.png";
import hypothalymusPlay from "../img/think-play.png";

import cnsCircle from "../img/brain-circle.png";
import medullaCircle from "../img/medulla-circle.png";
import cerebellumCircle from "../img/strong-circle.png";
import hippocampusCircle from "../img/seahorse-circle.png";
import cortexCircle from "../img/colorful-circle.png";
import hypothalymusCircle from "../img/think-circle.png";

export const assets = {
	cns: {
		icon: cnsIcon,
		playIcon: cnsPlay,
		circleIcon: cnsCircle,
		video: `https://www.youtube.com/watch?v=7x6HUNTnXUw`,
	},
	medulla: {
		icon: medullaIcon,
		playIcon: medullaPlay,
		circleIcon: medullaCircle,
		video: `https://www.youtube.com/watch?v=lM_sMfMc-t0`,
	},
	cerebellum: {
		icon: cerebellumIcon,
		playIcon: cerebellumPlay,
		circleIcon: cerebellumCircle,
		video: `https://www.youtube.com/watch?v=5JmBfJmNCKY`,
	},
	hippocampus: {
		icon: hippocampusIcon,
		playIcon: hippocampusPlay,
		circleIcon: hippocampusCircle,
		video: `https://www.youtube.com/watch?v=zHZRpG0au20`,
	},
	cortex: {
		icon: cortexIcon,
		playIcon: cortexPlay,
		circleIcon: cortexCircle,
		video: `https://www.youtube.com/watch?v=-Ui9B5GK3Tk`,
	},
	hypothalamus: {
		icon: hypothalymusIcon,
		playIcon: hypothalymusPlay,
		circleIcon: hypothalymusCircle,
		video: `https://www.youtube.com/watch?v=_pFq477c648`,
	},
};

export default {
	cns: [
		{
			prompt: `The study of the brain and nervous system.`,
			options: [`What is neuroscience?`, `What is nephrology?`, `What is audiology?`, `What is science?`],
			correctAnswer: `What is neuroscience?`,
			cashPrize: 200,
			bold: `Neuroscience `,
			response: `is the study of the brain and nervous system.`,
			color: `green`,
			type: `cns`,
		},
		{
			prompt: `A substance that slows down brain function.`,
			options: [`What is protein?`, `What is salt/saline?`, `What is alcohol?`, `What is caffeine?`],
			correctAnswer: `What is alcohol?`,
			cashPrize: 400,
			bold: `Alcohol `,
			response: `is the substance that slows down brain function.`,
			color: `green`,
			type: `cns`,
		},
		{
			prompt: `These two parts together create the central nervous system.`,
			options: [
				`What are the frontal lobe and temporal lobe?`,
				`What are the brain and spinal cord?`,
				`What is the brainstem and medulla?`,
				`What is the heart and lungs?`,
			],
			correctAnswer: `What are the brain and spinal cord?`,
			cashPrize: 600,
			bold: `The brain and spinal cord `,
			response: `work together to create the central nervous system.`,
			color: `green`,
			type: `cns`,
		},
		{
			prompt: `Chemical messengers that carry messages along the spinal cord between the brain and every part of the body.`,
			options: [
				`What are medullas?`,
				`What are neurotransmitters?`,
				`What are delegators?`,
				`What are couriers?`,
			],
			correctAnswer: `What are neurotransmitters?`,
			cashPrize: 800,
			bold: `Neurotransmitters `,
			response: `are chemical messengers that carry messages along the spinal cord between the brain and every part of the body.`,
			color: `green`,
			type: `cns`,
		},
	],
	medulla: [
		{
			prompt: `The sometimes deadly overdose of alcohol, that occurs when life-sustaining parts of the brain begin to shutdown`,
			options: [
				`What is alcohol poisoning?`,
				`What is a seizure?`,
				`What is impairment?`,
				`What is being buzzed?`,
			],
			correctAnswer: `What is alcohol poisoning?`,
			cashPrize: 200,
			bold: `Alcohol poisoning `,
			response: `is the deadly overdose of alcohol, that occurs when life-sustaining parts of the brain begin to shutdown.`,
			color: `blue`,
			type: `medulla`,
		},
		{
			prompt: `The system in your body that regulates breathing, controlled by the medulla.`,
			options: [
				`What is the endocrine system?`,
				`What is the circulatory system?`,
				`What is the central nervous system?`,
				`What is the respiratory system?`,
			],
			correctAnswer: `What is the respiratory system?`,
			cashPrize: 400,
			bold: `The respiratory system `,
			response: `in your body that regulates breathing, controlled by the medulla.`,
			color: `blue`,
			type: `medulla`,
		},
		{
			prompt: `This part of the brain connects it to the spinal cord and helps control basic body functions.`,
			options: [
				`What is the medulla?`,
				`What is the brainstem?`,
				`What is the limbic system?`,
				`What is the cerebellum?`,
			],
			correctAnswer: `What is the brainstem?`,
			cashPrize: 600,
			bold: `The brainstem `,
			response: `is the part of the brain that connects to the spinal cord and helps control basic body functions.`,
			color: `blue`,
			type: `medulla`,
		},
		{
			prompt: `Breathing and keeping a regular heart beat are examples of this type of action.`,
			options: [
				`What is exercise?`,
				`What is self-care?`,
				`What are vital involuntary actions?`,
				`What are voluntary actions?`,
			],
			correctAnswer: `What are vital involuntary actions?`,
			cashPrize: 800,
			bold: `Vital involuntary actions `,
			response: `are exampels of breathing and keeping a regular heart beat.`,
			color: `blue`,
			type: `medulla`,
		},
	],
	cerebellum: [
		{
			prompt: `This part is only 10% of the brains weight, but holds nearly half of its neurons.`,
			options: [
				`What is the cerebral cortex?`,
				`What is the hippocampus?`,
				`What is the cerebellum?`,
				`What is the medulla?`,
			],
			correctAnswer: `What is the cerebellum?`,
			cashPrize: 200,
			bold: `The cerebellum `,
			response: `is only 10% of the brains weight, but holds nearly half of its neurons.`,
			color: `pink`,
			type: `cerebellum`,
		},
		{
			prompt: `The skill that gives us the ability to speak clearly.`,
			options: [
				`What are reflexes?`,
				`What is cognitive dissonance?`,
				`What is verbal coordination or communication?`,
				`What is instinct?`,
			],
			correctAnswer: `What is verbal coordination or communication?`,
			cashPrize: 400,
			bold: `Coordination or communication `,
			response: `skills give us the ability to speak clearly.`,
			color: `pink`,
			type: `cerebellum`,
		},
		{
			prompt: `The cerebellum resembles this healthy vegetable.`,
			options: [`What is cauliflower?`, `What is asparagus?`, `What is an apple?`, `What is a gourd?`],
			correctAnswer: `What is cauliflower?`,
			cashPrize: 600,
			bold: `Cauliflower`,
			response: ` is the healthy vegetable that resembles the cerebellum.`,
			color: `pink`,
			type: `cerebellum`,
		},
		{
			prompt: `Scratching your ear and/or operating machinery are examples of involuntary and learned ___________.`,
			options: [`What are motor controls?`, `What are rotations?`, `What are robotics?`, `What is research?`],
			correctAnswer: `What are motor controls?`,
			cashPrize: 800,
			bold: `Motor controls `,
			response: ` are learend and involuntary examples of scratching your ear and/or operating machinery`,
			color: `pink`,
			type: `cerebellum`,
		},
	],
	hippocampus: [
		{
			prompt: `This brain part is responsible for storing and sorting memories.`,
			options: [
				`What is the brainstem?`,
				`What is the cerebellum?`,
				`What is the hippocampus?`,
				`What is the hypothalamus?`,
			],
			correctAnswer: `What is the hippocampus?`,
			cashPrize: 200,
			bold: `The hippocampus `,
			response: `is the part of the brain responsible for storing and sorting memories.`,
			color: `teal`,
			type: `hippocampus`,
		},
		{
			prompt: `The hippocampus was named after the Greek word for _______.`,
			options: [`What is a gecko?`, `What is a brain?`, `What is hippopotamus?`, `What is seahorse?`],
			correctAnswer: `What is seahorse?`,
			cashPrize: 400,
			bold: `Seahorse, `,
			response: `the Greek word the hippocampus was named after.`,
			color: `teal`,
			type: `hippocampus`,
		},
		{
			prompt: `The process of getting something back when it was stored elsewhere.`,
			options: [`What is retroaction?`, `What is recognition?`, `What is retrieval?`, `What is revival?`],
			correctAnswer: `What is retrieval?`,
			cashPrize: 600,
			bold: `Retrieval, `,
			response: `the process of getting something back when it was stored elsewhere.`,
			color: `teal`,
			type: `hippocampus`,
		},
		{
			prompt: `A set of structures in the brain responsible for emotions, memory, and natural human drives.`,
			options: [
				`What are neuro-tools?`,
				`What are neurotransmitters?`,
				`What is the limbic system?`,
				`What are hormones?`,
			],
			correctAnswer: `What is the limbic system?`,
			cashPrize: 800,
			bold: `The Limbic system,`,
			response: ` is a set of structures in the brain responsible for emotions, memory, and natural human drives.`,
			color: `teal`,
			type: `hippocampus`,
		},
	],
	cortex: [
		{
			prompt: `Functions of this brain part include thinking clearly and decision making.`,
			options: [
				`What is the medulla?`,
				`What is the cerebral cortex?`,
				`What is the hippocampus?`,
				`What is the hypothalamus?`,
			],
			correctAnswer: `What is the cerebral cortex?`,
			cashPrize: 200,
			bold: `The Cerebral Cortex `,
			response: ` is the part of the brain responsible for thinking clearly and decision making.`,
			color: `blue`,
			type: `cortex`,
		},
		{
			prompt: `Frontal, occipital, parietal, and temporal are the names of the four _____.`,
			options: [
				`What are the four types of motor skills?`,
				`What are the four lobes of the cerebral cortex?`,
				`What are the four types of neurotransmitters?`,
				`What are the four chambers of the heart?`,
			],
			correctAnswer: `What are the four lobes of the cerebral cortex?`,
			cashPrize: 400,
			bold: `Cerebral cortex: `,
			response: `frontal, occipital, parietal, and temporal.`,
			color: `blue`,
			type: `cortex`,
		},
		{
			prompt: `The skill controlled by the frontal lobe of the cerebral cortex that helps you weigh good and bad options.`,
			options: [
				`What is dexterity?`,
				`What is memory?`,
				`What is involuntary movement?`,
				`What is decision making?`,
			],
			correctAnswer: `What is decision making?`,
			cashPrize: 600,
			bold: `The decision making `,
			response: `skill is controlled by the frontal lobe of the cerebral cortex that helps you weigh good and bad options.`,
			color: `blue`,
			type: `cortex`,
		},
		{
			prompt: `Some describe this part of the brain as the wrinkly outer layer.`,
			options: [
				`What is the cerebellum?`,
				`What is the skin?`,
				`What is the medulla?`,
				`What is the cerebral cortex?`,
			],
			correctAnswer: `What is the cerebral cortex?`,
			cashPrize: 800,
			bold: `The cerebral cortex `,
			response: `is the part of the brain described as the wrinkly outer layer.`,
			color: `blue`,
			type: `cortex`,
		},
	],
	hypothalamus: [
		{
			prompt: `The hypothalamus is a tiny control center shaped like this healthy nut.`,
			options: [`What is a cashew?`, `What is an almond?`, `What is a hazelnut?`, `What is a walnut?`],
			correctAnswer: `What is an almond?`,
			cashPrize: 200,
			bold: `An almond`,
			response: ` is the shape of the hypothalamus, which is also the tiny control center.`,
			color: `gray`,
			type: `hypothalamus`,
		},
		{
			prompt: `The part of the brain that controls your hormone balance, which can be thrown off by drinking alcohol.`,
			options: [
				`What is the gray matter?`,
				`What is the hemoglobin?`,
				`What is the hypothalamus?`,
				`What is the cerebellum?`,
			],
			correctAnswer: `What is the hypothalamus?`,
			cashPrize: 400,
			bold: `The hypothalamus `,
			response: `is the part of the brain that controls your hormone balance, which can be thrown off by drinking alcohol.`,
			color: `gray`,
			type: `hypothalamus`,
		},
		{
			prompt: `This gland works with the hypothalamus to stimulate, inhibit, and release hormones.`,
			options: [
				`What is the pituitary gland?`,
				`What is the thyroid?`,
				`What is the renal gland?`,
				`What is the pancreas?`,
			],
			correctAnswer: `What is the pituitary gland?`,
			cashPrize: 600,
			bold: `The pituitary gland `,
			response: `works with the hypothalamus to stimulate, inhibit, and release hormones.`,
			color: `gray`,
			type: `hypothalamus`,
		},
		{
			prompt: `This substance increases blood pressure, hunger, and thirst.`,
			options: [`What is alcohol?`, `What is cholesterol?`, `What is plasma?`, `What is fat?`],
			correctAnswer: `What is alcohol?`,
			cashPrize: 800,
			bold: `Alcohol `,
			response: `is the substance increases blood pressure, hunger, and thirst.`,
			color: `gray`,
			type: `hypothalamus`,
		},
	],
};
